import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Button, Form, SectionDivider,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationOptionValue, { usePublicationOptionValueForm } from '@hooks/usePublicationOptionValue'
import usePublicationOptionValues from '@hooks/usePublicationOptionValues'

import PublicationOptionValueListItem from '../PublicationOptionValueListItem'

const handleAddOptionValue = (params) => {
  const {
    createPublicationOptionValue, createFn, entityState, setEntityState,
  } = params

  setEntityState({ title: '', value: '' })

  createPublicationOptionValue({
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    toastText: 'Publication Option Value Created',
  })
}

const PublicationOptionValueForm = (props) => {
  const {
    publication_option_id,
  } = props

  const { callbacks } = useContext(PageContext)
  const { createPublicationOptionValue } = callbacks || {}

  const valuesPayload = usePublicationOptionValues({
    filters: {
      publication_option_id,
    },
  })
  const {
    filteredPublicationOptionValues,
    hasFilteredPublicationOptionValues,
  } = valuesPayload

  const valuePayload = usePublicationOptionValue({ publication_option_id })
  const {
    callbacks: {
      createPublicationOptionValue: createFn,
    },
    creating: valueCreating,
    publicationOptionValue,
  } = valuePayload

  const valueFormPayload = usePublicationOptionValueForm(publicationOptionValue, { validateOn: 'change' })
  const {
    entityState,
    entityState: {
      title,
      value,
    },
    handlers,
    saveEnabled,
    setEntityState,
  } = valueFormPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>Add Option Value</SectionDivider>

      <Form.Field label="Option Title" marginTop="large">
        <input name="title" type="text" value={title} {...handlers} />
      </Form.Field>

      <Form.Field label="Option Value" marginTop="large">
        <input name="value" type="text" value={value} {...handlers} />
      </Form.Field>

      <Button
        buttonStyle="secondaryEdit"
        disabled={!saveEnabled}
        icon={<FontAwesomeIcon icon={faPlus} />}
        loading={valueCreating}
        marginTop="large"
        onClick={() => handleAddOptionValue({
          createPublicationOptionValue,
          createFn,
          entityState,
          setEntityState,
        })}
        size="medium"
      >
        {saveEnabled ? 'Create Option Value' : 'Complete Fields'}
      </Button>

      {hasFilteredPublicationOptionValues && (
        <>
          <SectionDivider boxProps={{ marginTop: 'large' }}>Option Values</SectionDivider>

          {filteredPublicationOptionValues.map(optionValue => (
            <PublicationOptionValueListItem
              key={optionValue.id}
              publicationOptionValue={optionValue}
            />
          ))}
        </>
      )}
    </>
  )
}

PublicationOptionValueForm.propTypes = {
  publication_option_id: PropTypes.number.isRequired,
}

export default PublicationOptionValueForm
